import React from 'react';
import { Navbar } from '../components/sections/Navbar';
import { Hero } from '../components/sections/Hero';
import { Benefits } from '../components/sections/Benefits';
import { Process } from '../components/sections/Process';
import { Areas } from '../components/sections/Areas';
import { Doctor } from '../components/sections/Doctor';
import { Authority } from '../components/sections/Authority';
import { Testimonials } from '../components/sections/Testimonials';
import { FAQ } from '../components/sections/FAQ';
import { Location } from '../components/sections/Location';
import { Contact } from '../components/sections/Contact';
import { Footer } from '../components/sections/Footer';
import { StickyMobileCta } from '../components/ui/StickyMobileCta';
export function Home() {
  return <main className="min-h-screen bg-brand-cream" data-id="element-424">
      <Navbar data-id="element-425" />
      <Hero data-id="element-426" />
      <Benefits data-id="element-427" />
      <Process data-id="element-428" />
      <Areas data-id="element-429" />
      <Doctor data-id="element-430" />
      <Authority data-id="element-431" />
      <Testimonials data-id="element-432" />
      <FAQ data-id="element-433" />
      <Location data-id="element-434" />
      <Contact data-id="element-435" />
      <Footer data-id="element-436" />
      <StickyMobileCta data-id="element-437" />
    </main>;
}